<div mat-dialog-title>
  <div class="dialog-header">
    <div class="title">Invite user</div>
    <div class="actions">
      <mat-icon svgIcon="close" class="action-icon" (click)="close()"></mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="create-record-content">

    <!-- Title -->
    <div class="row">
      <div class="title">Email</div>
      <input class="input" [(ngModel)]="email">
    </div>

    <!-- Team -->
    @if (team?.permissions | includesBy: 'admin:all') {
      <div class="row">
        <div class="title">Team</div>
        <app-select class="select" [options]="teamsOptions" [selected]="teamId" (selectedChange)="updateTeam($event)" placeholder="Select..."></app-select>
      </div>
    }

    <!-- Role -->
    <div class="row">
      <div class="title">Role</div>
      <app-select class="select" [options]="roleOptions" [selected]="role" (selectedChange)="updateRole($event)" placeholder="Select..."></app-select>
      <!-- <input class="input" [(ngModel)]="role"> -->
    </div>

    @if (error) {
      <div class="message error">{{ error }}</div>
    }

    @if (inviteLink) {
      <div class="message copy" (click)="copyLink()">{{ inviteLink }}</div>
    }

  </div>
</div>

<div mat-dialog-actions class="mat-dialog-actions dialog-actions">
  @if (!inviteLink) {
    <div class="button secondary" (click)="close()">Cancel</div>
    <div class="button" (click)="invite()">Invite</div>
  }
  @if (inviteLink) {
    <div class="button secondary" (click)="close()">Close</div>
    <div class="button" (click)="copyLink()">Copy</div>
  }
</div>
